<template lang="pug">
div.main
  h3 {{ titulo }}
  el-row(:gutter="2").margin
    el-col(:xl="24" :lg="24", :md="24", :sm="24")
      el-card.box-card(shadow="hover")
        slot.clearfix(name="header")
          h3 Quantidade de processo do analista - {{ $route.query.setor }}
        div.margin(v-if="produtividadeTipoProcesso")
          grafico-produtividade(:usuario="$route.query.analista", :dadosLabels="produtividadeTipoProcesso", @totalProcessos = 'setTotalProcessos')

  el-row(:gutter="2").margin
    el-col(:xl="24" :lg="24", :md="24", :sm="24")
      el-card.box-card(shadow="hover")
        slot.clearfix(name="header")
          h3 Produtividade mensal do colaborador
        div.margin
          grafico-mensal(
            :produtividadeUsuario="produtividadeAnalista.produtividadePeriodoAnoMesUsuario",
            :mediasWithDataArray="produtividadeAnalista.mediaProdutividadePeriodoAnoMes",
        )
  div.content(v-if="produtividadeAnalista.processosAnalisados")
    app-modal-visualizar-completo(
      v-if="showModal"
      :showModal="showModal"
      @closeModal="showModal = false"
      :idProcesso="idProcesso"
      :protocolo="protocolo"
      :numeroProcesso="numeroProcesso"
      :tipo="tipoProcesso"
    )
    el-card.box-card(shadow="hover")
      .card-header
        .titulo Processos analisados
      el-table(
        :data='produtividadeAnalista.processosAnalisados.content',
        v-loading="loading",
        element-loading-text="Carregando...",
        @sort-change="sort",
      )
        template(slot="empty") Não há registros.
        el-table-column(
          prop='numeroProcesso',
          label='Processo',
          width="auto",
          sortable
        )
        el-table-column(
          prop='setor',
          label='Setor',
          width="auto",
          sortable
        )
        el-table-column(
          prop='nomeRazaoSocialInteressado',
          label='Nome do interessado',
          width="auto",
          sortable
        )
        el-table-column(
          prop='nomeRazaoSocialUsuario',
          label='Técnico responsável',
          width="auto",
          sortable
        )
        el-table-column(
          prop='tipo',
          label='Tipo de processo',
          width="auto",
          sortable
        )
        el-table-column(
          prop='municipio',
          label='Município',
          width="auto",
          sortable
        )
        el-table-column(
          label='Ações',
          width='120',
          align='center'
        )
          template(slot-scope='scope')
            el-dropdown(trigger="click")
              el-button(type='primary', size="small")
                | Ações
                i.el-icon-arrow-down.el-icon--right
              el-dropdown-menu(slot='dropdown')
                el-dropdown-item
                  .flex(@click="abreModal(scope.row)")
                    i.fa.fa-eye
                    | &nbsp Visualizar processo
      div.pagination
        app-paginacao(
          :total="produtividadeAnalista.processosAnalisados.totalElements"
          :pagina="currentPage",
          @changePage="changePage",
          :tamanhoPagina="15"
        )
  .margin
    el-button.btn(
      type="default"
      @click="voltar()"
    )
      i.fa.fa-chevron-left
      | &nbsp Voltar
</template>

<script>
import {mapActions} from 'vuex'
import GraficoMensal from './components/GraficoMensal'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto.vue'
import AppPaginacao from '@/components/AppPaginacao'
import GraficoProdutividade from './components/produtividadeAnalista/GraficoProdutividade'
const { nomesSetores } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
    nomesSetores,
    GraficoMensal,
    AppModalVisualizarCompleto,
    GraficoProdutividade,
    AppPaginacao
  },

  async created () {
    const produtividade = await this.findProdutividadeUsuario(this.$route.query)

    // Produtividade do técnico por tipo de processo
    this.produtividadeTipoProcesso = produtividade.processosPorTipo

    // Verificações para tratar problema no f5 da fazendo com que arrays com 1 elementos se tornasse apenas uma string
    if (this.$route.query.perfis && !Array.isArray(this.$route.query.perfis)) {
      this.$route.query.perfis = [this.$route.query.perfis]
    }

    if (this.$route.query.municipios && !Array.isArray(this.$route.query.municipios)) {
      this.$route.query.municipios = [this.$route.query.municipios]
    }

    if (this.$route.query.acoes && !Array.isArray(this.$route.query.acoes)) {
      this.$route.query.acoes = [this.$route.query.acoes]
    }

    this.setTitulo()

    this.produtividadeAnalista = produtividade
  },

  data () {
    return {
      titulo: String,
      isLoading: false,
      setor: String,
      filtro: {},
      tipoProcesso: null,
      produtividadeTipoProcesso: [],
      produtividadeAnalista: {
        produtividadePeriodoAnoMesUsuario: [],
        mediaProdutividadePeriodoAnoMes: [],
        processosAnalisados: null
      },
      currentPage: 1,
      showModal: false,
      idProcesso: null,
      protocolo: null,
      numeroProcesso: null,
      loading: false
    }
  },

  methods: {
    ...mapActions({
      findProdutividadeUsuario: 'produtividade/findProdutividadeUsuario'
    }),

    getSetorBySigla (sigla) {
      return nomesSetores[sigla]
    },

    setTitulo () {
      const sigleSetor = this.$route.query.setor
      this.titulo = sigleSetor + ' - ' + this.getSetorBySigla(sigleSetor)
    },

    async changePage (newPage) {
      this.currentPage = newPage
      this.$route.query.pagina = newPage - 1

      this.produtividadeAnalista = await this.findProdutividadeUsuario(this.$route.query)
    },

    async sort (data) {
      let ordem = ''

      switch (data.prop) {
        case 'numeroProcesso':
          ordem = 'p.numero_processo'
          break
        case 'setor':
          ordem = 'vp.setor'
          break
        case 'nomeRazaoSocialInteressado':
          ordem = 'p.interessado_nome_razao_social'
          break
        case 'nomeRazaoSocialUsuario':
          ordem = 'vp.nome_razao_social_usuario'
          break
        case 'tipo':
          ordem = 'tc.nome'
          break
        case 'municipio':
          ordem = "split_part(vp.municipios_nome, ',', 1)"
          break
        default:
          ordem = null
          break
      }

      if (ordem) {
        this.$route.query.ordem = ordem + ' ' + (data.order === 'ascending' ? 'ASC' : 'DESC')
      }

      this.produtividadeAnalista = await this.findProdutividadeUsuario(this.$route.query)
    },

    setTotalProcessos (total) {
      this.totalProcessos = total
    },

    abreModal (row) {
      this.idProcesso = row.idProcesso
      this.protocolo = row.protocolo
      this.numeroProcesso = row.numeroProcesso
      this.tipoProcesso = row.codigo
      this.showModal = true
    },

    voltar () {
      this.$router.push({
        name: 'produtividade/setor',
        params: {
          setor: this.$route.query.setor
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

  .main {
    padding: 2% 11% 2% 11%
  }

  .titulo {
    color: #424242;
    font-weight: bold;
    font-size: 20px;
    margin-top: 0px;
  }

  .margin {
    margin-top: 20px;
  }

  .margin-buttom {
    margin-top: 3.5em;
  }

  .full-width {
    width: 100%;
  }

  .margin-bottom {
    margin-bottom: 20px;
  }

  .div-total {
    padding: 2% 0 0 2%;
    font-size: 14px;
  }

  .box-card {
    margin: 2px;
    border-radius: 12px;
  }

  .content {
    margin-top: 3.5em;
  }
  .pagination {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/screens/produtividade/ProdutividadeSetorPorAnalista.vue